import React, { Component } from 'react'
import { Routes, Route} from "react-router-dom";
import { connect } from 'react-redux';
import { fetchServers } from '../actions/servers';
import { CSVLink } from "react-csv"
import LoadingControl from '../controls/Loading';
import DownloadButton from '../controls/DownloadButton';
import '../App.css';
import ServersTable from '../controls/ServersTable';
import ServerReportRouter from '../controls/ServerReport';
 
class FullServers extends Component {

    constructor(props) {
        super(props);
    
        this.state = {
          csvData: [],
        };
      }
  
    componentDidMount() {
        this.props.fetchData();
    }      

    onCSVExportClick()
    {
      this.setState({ csvData: this.props.items }, () => {
        // click the CSVLink component to trigger the CSV download
        this.csvLink.link.click()}
      );

    }

    render() {
        if(this.props.hasError != null)
        {
            return (
                <div><h3>{this.props.hasError.message}</h3></div>
            );
        }
        else if (this.props.isLoading)
        {
            return (
                <div><LoadingControl/></div>
            );
        }
        else
        {
            return (
                <div className = "history-pane-header">
                    <div className = "range-picker">&#8202;</div>
                    <CSVLink 
                    data={this.state.csvData}
                    separator=";"
                    ref={(r) => this.csvLink = r}
                    filename="servers.csv"
                    className="hidden"
                    target="_blank">                
                    </CSVLink>
                    <DownloadButton onCSVExport = {() => {this.onCSVExportClick()}}/> 
                    <ServersTable data = {this.props.items} />
                </div>
            );
        }
    }
}

const mapStateToProps = (state) => {
    return {
        items: state.servers,
        hasError: state.serversHasError,
        isLoading: state.serversIsLoading,
    };
  };     
  
  const mapDispatchToProps = (dispatch) => {
  return {
      fetchData: () => dispatch(fetchServers()),
    };
  };

const Servers = connect(mapStateToProps, mapDispatchToProps)(FullServers);

const ServersPane = (props) => {  
  
    return (
        <div>
            <Routes>
                <Route path={"/"} element={<Servers/>}/>
                <Route path=':id' element={<ServerReportRouter/>}/>
            </Routes>
        </div>
    );
}
  
export default ServersPane;